import { render, staticRenderFns } from "./CarrierSettings.vue?vue&type=template&id=207f2853&scoped=true&"
import script from "./CarrierSettings.vue?vue&type=script&lang=js&"
export * from "./CarrierSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f2853",
  null
  
)

export default component.exports